import React, { useEffect, useState, useRef } from "react";
// import { FaHotel } from "react-icons/fa";
import { Tooltip, Tabs, Tab, Box, CircularProgress } from "@mui/material";
import AutoAwesomeMosaicIcon from '@mui/icons-material/AutoAwesomeMosaic';
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import { useForm } from "react-hook-form";
import { callAPI } from "../../../../axios";
import './RailConfig.scss';
import PartnerRails from "./PartnerRails";
import ChannelsForYou from "./ChannelsForYou";
import BasicModal from "../../../core/BaseComponents/Modal";
import TableWrapper from "../../../core/BaseComponents/TableWrapper/TableWrapper";
import { useSelector } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import { MdModeEditOutline } from "react-icons/md";
import deleteImg from '../../../../assets/images/delete.png';
import { IoMdWarning } from "react-icons/io";
import { ScrollToTop, getChainIdLS, isValidRole } from "../../../../utils/utils";
import dayjs from "dayjs";
import RailConfigPreview from "./RailConfigPreview";
import { BsEye } from "react-icons/bs";
// import Custom_Paingation from "../../../core/BaseComponents/Custom_Paingation";
import HotelServices from "./HotelServices";
import HotelChannels from "./HotelChannels";
import Utility from "./Utility";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBellConcierge,
  faGear,
  faShareNodes
} from "@fortawesome/free-solid-svg-icons";
const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      className="tabpanelcustom"
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
          {/* <Typography>{children}</Typography> */}
        </Box>
      )}
    </div>
  );
};

const RailConfig = () => {
  const [value, setValue] = useState(1);
  const [editPublishUnPublishUpdate, setEditPublishUnPublishUpdate] = useState(false);
  const [editPublishUnPublish, setEditPublishUnPublish] = useState(false);
  const [publishUnPublishSid, setPublishUnPublishSid] = useState({});
  // const [publishUnPublishPopUp, setPublishUnPublishPopUp] = useState(false);

  const [confirmDeletePublishUnPublish, setConfirmDeletePublishUnPublish] = useState("");
  const [confirmValidate, setConfirmValidate] = useState(false);
  const [deletePublishUnPublishPopUp, setDeletePublishUnPublishPopUp] = useState(false);

  const [createRailSuccessMsg, setCreateRailSuccessMsg] = useState('');

  const [railsConfigurationList, setRailsConfigurationList] = useState([])
  const [flag, setFlag] = useState(false);

  const [partnerRailData, setPartnerRailData] = useState([{partnerId: 4, sequenceNo: 0}])
  const [channelForYouData, setChannelForYouData] = useState([])
  const [hotelServiceData, setHotelServiceData] = useState([])
  const [HotelChannelData, setHotelChannelData] = useState([])
  const [utilityData, setUtilityData] = useState([])

  const [originalChannelForYouData, setOriginalChannelForYouData] = useState([])
  const [originalPartnerRailData, setOriginalPartnerRailData] = useState([])
  const [originalHotelServiceData, setOriginalHotelServiceData] = useState([])
  const [originalHotelChannelData, setOriginalHotelChannelData] = useState([])
  const [originalUtilityData, setOriginalUtilityData] = useState([])

  const [originalSelectedChannelForYouFullObject, setOriginalSelectedChannelForYouFullObject] = useState([])
  const [originalSelectedPartnerFullObject, setOriginalSelectedPartnerFullObject] = useState([])
  const [originalSelectedHotelServiceFullObject, setOriginalSelectedHotelServiceFullObject] = useState([])
  const [originalSelectedHotelChannelFullObject, setOriginalSelectedHotelChannelFullObject] = useState([])
  const [originalSelectedUtilityFullObject, setOriginalSelectedUtilityFullObject] = useState([])


  const [masterPartnerList, setMasterPartnerList] = useState([]);
  const [masterGenresList, setMasterGenresList] = useState([]);
  const [masterChannelsList, setMasterChannelsList] = useState([]);
  const [masterHotelServiceList, setMasterHotelServiceList] = useState([])
  const [masterHotelChannelList, setMasterHotelChannelList] = useState([])
  const [masterUtilityList, setMasterUtilityList] = useState([])

  const [preview, setPreview] = useState(false);
  const [previewListRowData, setRreviewListRowData] = useState({});

  const [selectedChannelForYouFullObject, setSelectedChannelForYouFullObject] = useState([])
  const [selectedPartnerFullObject, setSelectedPartnerFullObject] = useState([])
  const [selectedHotelServiceFullObject, setSelectedHotelServiceFullObject] = useState([])
  const [selectedHotelChannelFullObject, setSelectedHotelChannelFullObject] = useState([])
  const [selectedUtilityFullObject, setSelectedUtilityFullObject] = useState([])

  const [payloadPartner, setPayloadPartner] = useState({ partners: [] })
  const [payloadChannelsForYou, setPayloadChannelsForYou] = useState({ channelCategories: [] })
  const [payloadHotelService, setPayloadHotelService] = useState({ hotelServices: [] })
  const [payloadHotelChannel, setPayloadHotelChannel] = useState({ hotelChannelSequence: [] });
  const [payloadUtility, setPayloadUtility] = useState({utility: []})
  const [isDragging, setIsDragging] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [showUtility, setShowUtility] = useState(true)
  const [showUtilityOriginal, setShowUtilityOriginal] = useState(true)

  let validPermissionClassName = isValidRole("RAIL_CONFIGURATION_MODIFY")
    ? ""
    : "btn-disable-permission";

  const [tabs, setTabs] = useState([
    { id: 1, sequenceNo: 1, railName: "utility", label: "Utilities", icon: <FontAwesomeIcon icon={faGear} className="fa-lg" /> },
    { id: 2, sequenceNo: 2, railName: "hotelService", label: "Hotel Services", icon: <FontAwesomeIcon icon={faBellConcierge} className="fa-lg" /> },
    { id: 3, sequenceNo: 3, railName: "partner", label: "Partner Rail", icon: <AutoAwesomeMosaicIcon className="tab-icons" /> },
    { id: 4, sequenceNo: 4, railName: "linearChannel", label: "Tata play Linear Channels", icon: <AutoAwesomeMotionIcon className="tab-icons" /> },
    { id: 5, sequenceNo: 5, railName: "hotelChannel", label: "Hotel Channels", icon: <FontAwesomeIcon icon={faShareNodes} className="fa-lg" /> }
  ])

  const originalTabs = [
    { id: 1, sequenceNo: 1, railName: "utility", label: "Utilities", icon: <FontAwesomeIcon icon={faGear} className="fa-lg" /> },
    { id: 2, sequenceNo: 2, railName: "hotelService", label: "Hotel Services", icon: <FontAwesomeIcon icon={faBellConcierge} className="fa-lg" /> },
    { id: 3, sequenceNo: 3, railName: "partner", label: "Partner Rail", icon: <AutoAwesomeMosaicIcon className="tab-icons" /> },
    { id: 4, sequenceNo: 4, railName: "linearChannel", label: "Tata play Linear Channels", icon: <AutoAwesomeMotionIcon className="tab-icons" /> },
    { id: 5, sequenceNo: 5, railName: "hotelChannel", label: "Hotel Channels", icon: <FontAwesomeIcon icon={faShareNodes} className="fa-lg" /> }
  ]

  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
      className: `eachtab ${value === index ? 'Mui-selected' : ''}`,
    };
  }

  const onDragEnd = result => {
    if (!result.destination) return;
    if (result.destination.index === result.source.index) return;

    const newTabs = Array.from(tabs);
    const [removed] = newTabs.splice(result.source.index, 1);
    newTabs.splice(result.destination.index, 0, removed);

    // Update sequenceNo based on new index
    const updatedTabs = newTabs.map((tab, index) => ({
      ...tab,
      sequenceNo: index + 1, // Setting sequenceNo to 1-based index
    }));

    setTabs(updatedTabs);
    setIsDragging(false);
  };

  const renderTabContent = () => {
    const currentTab = tabs[value];

    switch (currentTab.id) {
      case 1:
        return <Utility showUtility={showUtility} setShowUtility={setShowUtility} onResetHotelChannel={onResetUtility} tabs={tabs} setPayloadHotelChannel={setPayloadUtility} setHotelChannelData={setUtilityData} defaultValue={utilityData} masterHotelChannelList={masterUtilityList} onSubmitHandler={onSubmitHandler} editPublishUnPublish={editPublishUnPublish} railName={watch('railName')} roomTypes={watch('roomTypes')} onResetHandler={onResetHandler} selectedHotelChannelFullObject={selectedHotelChannelFullObject} selectedChannelForYouFullObject={selectedChannelForYouFullObject} setSelectedHotelChannelFullObject={setSelectedUtilityFullObject} selectedPartnerFullObject={selectedPartnerFullObject} selectedHotelServiceFullObject={selectedHotelServiceFullObject} tabChangeHandler={tabChangeHandler} />;
      case 2:
        return <HotelServices showUtility={showUtility} selectedUtilityFullObject={selectedUtilityFullObject} onResetHotelService={onResetHotelService} tabs={tabs} setPayloadHotelService={setPayloadHotelService} tabChangeHandler={tabChangeHandler} selectedHotelChannelFullObject={selectedHotelChannelFullObject} setHotelServiceData={setHotelServiceData} defaultValue={hotelServiceData} masterHotelServiceList={masterHotelServiceList} onSubmitHandler={onSubmitHandler} editPublishUnPublish={editPublishUnPublish} onResetHandler={onResetHandler} railName={watch('railName')} roomTypes={watch('roomTypes')} selectedChannelForYouFullObject={selectedChannelForYouFullObject} setSelectedHotelServiceFullObject={setSelectedHotelServiceFullObject} selectedPartnerFullObject={selectedPartnerFullObject} />;
      case 3:
        return <PartnerRails showUtility={showUtility} selectedUtilityFullObject={selectedUtilityFullObject} onResetPartner={onResetPartner} tabs={tabs} setPayloadPartner={setPayloadPartner} selectedHotelChannelFullObject={selectedHotelChannelFullObject} selectedHotelServiceFullObject={selectedHotelServiceFullObject} selectedChannelForYouFullObject={selectedChannelForYouFullObject} railName={watch('railName')} roomTypes={watch('roomTypes')} onResetHandler={onResetHandler} setPartnerRailData={setPartnerRailData} editPublishUnPublish={editPublishUnPublish} tabChangeHandler={tabChangeHandler} onSubmitHandler={onSubmitHandler} masterPartnerList={masterPartnerList} defaultValue={partnerRailData} setSelectedPartnerFullObject={setSelectedPartnerFullObject} />;
      case 4:
        return <ChannelsForYou showUtility={showUtility} selectedUtilityFullObject={selectedUtilityFullObject} onResetChannelsForYou={onResetChannelsForYou} selectedPartnerFullObject={selectedPartnerFullObject} tabs={tabs} setPayloadChannelsForYou={setPayloadChannelsForYou} selectedHotelChannelFullObject={selectedHotelChannelFullObject} selectedHotelServiceFullObject={selectedHotelServiceFullObject} defaultValuePartner={partnerRailData} setSelectedChannelForYouFullObject={setSelectedChannelForYouFullObject} onResetHandler={onResetHandler} setChannelForYouData={setChannelForYouData} railName={watch('railName')} roomTypes={watch('roomTypes')} editPublishUnPublish={editPublishUnPublish} masterPartnerList={masterPartnerList} tabChangeHandler={tabChangeHandler} onSubmitHandler={onSubmitHandler} masterGenresList={masterGenresList} masterChannelsList={masterChannelsList} defaultValue={channelForYouData} />;
      case 5:
        return <HotelChannels showUtility={showUtility} selectedUtilityFullObject={selectedUtilityFullObject} onResetHotelChannel={onResetHotelChannel} tabs={tabs} setPayloadHotelChannel={setPayloadHotelChannel} setHotelChannelData={setHotelChannelData} defaultValue={HotelChannelData} masterHotelChannelList={masterHotelChannelList} onSubmitHandler={onSubmitHandler} editPublishUnPublish={editPublishUnPublish} railName={watch('railName')} roomTypes={watch('roomTypes')} onResetHandler={onResetHandler} selectedChannelForYouFullObject={selectedChannelForYouFullObject} setSelectedHotelChannelFullObject={setSelectedHotelChannelFullObject} selectedPartnerFullObject={selectedPartnerFullObject} selectedHotelServiceFullObject={selectedHotelServiceFullObject} tabChangeHandler={tabChangeHandler} />;
    }
  };

  const {
    register,
    // handleSubmit,
    formState: { errors },
    reset,
    control,
    watch
  } = useForm({
    mode: 'onChange',
  });

  const { chainId } = useSelector((state) => state.chainIdReducer);

  useEffect(() => {
    callAPI("/master/getActivePartners", "GET")
      .then((response) => {
        const partnersList = response?.map((partners) => ({
          ...partners,
          name: partners.logoTitle,
          id: partners.sid,
          logo: partners.logoUrl,
        }));

        setMasterPartnerList(partnersList);
      })
      .catch((err) => console.warn(err.message));
    callAPI("/master/channels", "GET")
      .then((response) => {
        setMasterGenresList(response?.distinctGenres);
        const updatedResponse = response?.genreChannelMapping?.map(
          (channels) => ({
            ...channels,
            name: channels.title,
            id: channels.sid ,
            logo: channels.thumbnailImage,
          })
        );
        setMasterChannelsList(updatedResponse);
      })
      .catch((err) => console.warn(err.message));
    callAPI("/utility_rail", "GET")
      .then((response) => {
        const utilityList = response?.map((utility) => ({
          ...utility,
          name: utility.title,
          id: utility.id,
          logo: utility.thumbnailUrl,
        }));

        setMasterUtilityList(utilityList);
      })
      .catch((err) => console.warn(err.message));
  }, []);

  useEffect(() => {
    callAPI("/hotel-special-default/rail-special", "GET")
      .then((response) => {
        const partnersList = response?.map((partners) => ({
          ...partners,
          name: partners.menuName,
          // id: partners.sid,
          logo: partners.menuImageUrl,
        }));
        setMasterHotelServiceList(partnersList);
      })
      .catch((err) => console.warn(err.message));
    callAPI("/hotel-channel-default/rail-special", "GET")
      .then((response) => {
        const updatedResponse = response?.map(
          (channels) => ({
            ...channels,
            name: channels.channelName,
            id: channels.sid,
            logo: channels.channelLogo,
          })
        );
        setMasterHotelChannelList(updatedResponse);
      })
      .catch((err) => console.warn(err.message));
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const renderActionIcon = (row) => {
    return (
      isValidRole("RAIL_CONFIGURATION_MODIFY")?<>
          <>
            <Tooltip title="Edit" arrow>
              <span>
                <MdModeEditOutline
                  className="edit-icon-enable"
                  onClick={() => onEditClickHandler(row)}
                />
              </span>
            </Tooltip>
            {!(publishUnPublishSid?.sid == row?.sid) ? <Tooltip title="Delete" arrow>
              <DeleteIcon
                className="delete-icon-enable"
                onClick={() => {
                  deletePublishUnPublishPopUpHandler(row);
                }}
              />
            </Tooltip>:<Tooltip title="Cancel edit mode to perform actions">
              <DeleteIcon className="delete-icon-disable" arrow />
            </Tooltip>
            }
          </>
      </>: <>
        <Tooltip title="Don't have permission to edit">
          <span>
            <MdModeEditOutline className="edit-icon-disable" arrow />
          </span>
        </Tooltip>
        <Tooltip title="Don't have permission to delete">
          <DeleteIcon className="delete-icon-disable" arrow />
        </Tooltip>
      </>
    );
  };

  const onEditClickHandler = (row)=>{
    getPublishUnPublishListSidHandler(row)
    setEditPublishUnPublish(true);
    setPublishUnPublishSid(row);
     setIsEdit(true);
    ScrollToTop()
  }

  const getPublishUnPublishListSidHandler = (row) => {
    setLoader(true);
    callAPI(`/rails-default/${row?.sid}`, "GET")
      .then(function (response) {
        if(response?.railOrder?.length){
          const sequenceMap = Object.fromEntries(response?.railOrder?.map(item => [item.railName, item.sequenceNo]));
          // Update each tab’s sequenceNo based on the railOrder data
          const updatedTabs = tabs.map(tab => ({
            ...tab,
            sequenceNo: sequenceMap[tab.railName] || tab.sequenceNo, // use existing sequenceNo if not found in API data
          }));
          // Sort the tabs by the new sequenceNo and update the state
          setTabs(updatedTabs.sort((a, b) => a.sequenceNo - b.sequenceNo));
        }
        else{
          setTabs(originalTabs)
        }
        setPayloadPartner({ partners:response?.partners })
        setPayloadChannelsForYou({ channelCategories: response?.channelCategories })
        setPayloadHotelService({ hotelServices: response?.hotelServices })
        setPayloadHotelChannel({ hotelChannelSequence: response?.hotelChannelSequence })
        const payload = {
          railName: response?.railName,
          roomTypes: response?.roomTypes,
          //   welcomeMessage: response?.welcomeMessage
        };
        const partnerApiData = response?.partners?.sort((a, b) => a.sequenceNo - b.sequenceNo)
        setPartnerRailData(partnerApiData)
        setOriginalPartnerRailData(partnerApiData)
        if (response?.partners?.length) {
          const defaultSids = partnerApiData.map((item) => item.partnerId);
          const defaultPartners = masterPartnerList?.filter((partnerData) =>defaultSids.includes(partnerData?.sid))
          const sequenceData = defaultPartners?.map((partner)=>({...partner, sequenceNo: partnerApiData?.find(def=>def?.partnerId === partner?.sid)?.sequenceNo}))
          const sortedData = sequenceData?.sort((a,b)=>a.sequenceNo - b.sequenceNo)
          setSelectedPartnerFullObject(sortedData)
          setOriginalSelectedPartnerFullObject(sortedData)
        }
        const linearChannelApiData = response?.channelCategories?.map(category => {
          return {
            ...category,
            // Sort the channels within each category by sequenceNo
            channels: category.channels?.sort((a, b) => a.sequenceNo - b.sequenceNo)
          };
        }).sort((a, b) => a.sequenceNo - b.sequenceNo);
        setChannelForYouData(linearChannelApiData)
        setOriginalChannelForYouData(linearChannelApiData)
        if (response?.channelCategories?.length) {
          // Create a deep copy of defaultValue
          const updatedPayload = linearChannelApiData?.map(channelData => ({ ...channelData }));
          const defaultSids = linearChannelApiData?.map((channel) => channel?.channels?.map((item) => item?.channelId));
          const channelDefaultData = linearChannelApiData?.map((channel) => channel?.channels?.map((item) => ({...item})));
          // Map over the defaultValue to add availableChannels
          const addedChannelsPayload = updatedPayload.map((channelData,index) => ({
            ...channelData,
            channels: masterChannelsList.filter(channel =>
              channelData?.genres?.includes(channel?.genre) && defaultSids[index]?.includes(channel?.sid)),
            availableChannels: masterChannelsList.filter(channel =>
              channelData?.genres?.includes(channel?.genre) && !defaultSids[index]?.includes(channel?.sid)
            ),
          }));
          const sequenceAddedData = addedChannelsPayload?.map((channelData,index)=>({...channelData, channels: channelData?.channels?.map((channel)=>({...channel, sequenceNo:channelDefaultData[index]?.find(def=>def?.channelId === channel?.sid)?.sequenceNo}))}))
          const sortedData = sequenceAddedData?.map((channelData)=>({...channelData,channels: channelData?.channels?.sort((a,b)=>a.sequenceNo-b.sequenceNo)}))
          // Update steps with the modified payload
          setSelectedChannelForYouFullObject(sortedData);
          setOriginalSelectedChannelForYouFullObject(sortedData)
        }
        const hotelServiceApiData = response?.hotelServices?.sort((a, b) => a.sequenceNo - b.sequenceNo)
        setHotelServiceData(hotelServiceApiData)
        setOriginalHotelServiceData(hotelServiceApiData)
        if (response?.hotelServices?.length) {
          const defaultSids = hotelServiceApiData.map((item) => item.hotelServiceId);
          const defaultHotelsService = masterHotelServiceList?.filter((HotelsServiceData) => defaultSids.includes(HotelsServiceData?.id))
          const sequenceData = defaultHotelsService?.map((HotelsService) => ({ ...HotelsService, sequenceNo: hotelServiceApiData?.find(def => def?.hotelServiceId === HotelsService?.id)?.sequenceNo }))
          const sortedData = sequenceData?.sort((a, b) => a.sequenceNo - b.sequenceNo)
          setSelectedHotelServiceFullObject(sortedData)
          setOriginalSelectedHotelServiceFullObject(sortedData)
        }
        const hotelChannelApiData = response?.hotelChannelSequence?.sort((a, b) => a.sequenceNo - b.sequenceNo)
        setHotelChannelData(hotelChannelApiData)
        setOriginalHotelChannelData(hotelChannelApiData)
        if (response?.hotelChannelSequence?.length) {
          const defaultSids = hotelChannelApiData.map((item) => item.hotelChannelId);
          const defaultHotelsChannel = masterHotelChannelList?.filter((HotelsChannelData) => defaultSids.includes(HotelsChannelData?.id))
          const sequenceData = defaultHotelsChannel?.map((HotelsChannel) => ({ ...HotelsChannel, sequenceNo: hotelChannelApiData?.find(def => def?.hotelChannelId === HotelsChannel?.id)?.sequenceNo }))
          const sortedData = sequenceData?.sort((a, b) => a.sequenceNo - b.sequenceNo)
          setSelectedHotelChannelFullObject(sortedData)
          setOriginalSelectedHotelChannelFullObject(sortedData)
        }
        setShowUtility(response?.showUtilities)
        setShowUtilityOriginal(response?.showUtilities)
        const utilityApiData = response?.utility?.sort((a, b) => a.sequenceNo - b.sequenceNo)
        setUtilityData(utilityApiData)
        setOriginalUtilityData(utilityApiData)
        if (response?.utility?.length) {
          const defaultSids = utilityApiData.map((item) => item.utilityId);
          const defaultUtilityData = masterUtilityList?.filter((utilityDataMap) =>defaultSids.includes(utilityDataMap?.id))
          const sequenceData = defaultUtilityData?.map((utility)=>({...utility, sequenceNo: utilityApiData?.find(def=>def?.utilityId === utility?.id)?.sequenceNo}))
          const sortedData = sequenceData?.sort((a,b)=>a.sequenceNo - b.sequenceNo)
          setSelectedUtilityFullObject(sortedData)
          setOriginalSelectedUtilityFullObject(sortedData)
        }
        reset(payload);
        setEditPublishUnPublishUpdate(true);
        setLoader(false);
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
        setLoader(false);
      });
  }

  const onResetHandler = () =>{
    setChannelForYouData(originalChannelForYouData)
    setSelectedChannelForYouFullObject(originalSelectedChannelForYouFullObject)

    setPartnerRailData(originalPartnerRailData)
    setSelectedPartnerFullObject(originalSelectedPartnerFullObject)

    setHotelServiceData(originalHotelServiceData)
    setSelectedHotelServiceFullObject(originalSelectedHotelServiceFullObject)

    setHotelChannelData(originalHotelChannelData)
    setSelectedHotelChannelFullObject(originalSelectedHotelChannelFullObject)

    setUtilityData(originalUtilityData)
    setSelectedUtilityFullObject(originalSelectedUtilityFullObject)
    // setResetFlag((prev)=>!prev)
    setTabs(originalTabs)
  }

  const onResetPartner = () =>{
    setPartnerRailData(originalPartnerRailData)
    setSelectedPartnerFullObject(originalSelectedPartnerFullObject)
  }

  const onResetChannelsForYou = () =>{
    setChannelForYouData(originalChannelForYouData)
    setSelectedChannelForYouFullObject(originalSelectedChannelForYouFullObject)
  }

  const onResetHotelService = () => {
    setHotelServiceData(originalHotelServiceData)
    setSelectedHotelServiceFullObject(originalSelectedHotelServiceFullObject)
  }

  const onResetUtility = () =>{
    setUtilityData(originalUtilityData)
    setSelectedUtilityFullObject(originalSelectedUtilityFullObject)
    setShowUtility(showUtilityOriginal)
  }

  const onResetHotelChannel = () => {
    setHotelChannelData(originalHotelChannelData)
    setSelectedHotelChannelFullObject(originalSelectedHotelChannelFullObject)
  }

  // const publishUnPublishPopUpHandler = (row) => {
  //   setPublishUnPublishPopUp(true);
  //   const newModalRefData = {
  //     isPublishUnPublishModalData: {
  //       message: `Do you really want to ${!row?.published ? 'Publish' : 'Un-Publish'} the rail configuration?`,
  //       row
  //     }
  //   };
  //   isPublishedUnPublishedRef.current = newModalRefData;
  // }

  const deletePublishUnPublishHandler = () => {
    setConfirmValidate(true);
    if (confirmDeletePublishUnPublish === "") {
      return
    }

    if (confirmDeletePublishUnPublish === `Delete Rail Configuration ${isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData.row.railName}`) {
      setConfirmValidate(false)
      const { row } = isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData;
      setLoader(true);
      callAPI(`/rails-default/${row?.sid}`, "DELETE")
        .then((response) => {
          let successMessage = response.message
          const newModalRefData = {
            isPublishUnPublishDeletedModalData: null,
            userConformationModalData: {
              successMessage
            },
          };
          isPublishUnPublishDeletedRef.current = newModalRefData;
          railConfigurationListApi();
          setLoader(false);
        })
        .catch((error) => {
          console.warn(error)
          setLoader(false);
        });
    }
    reset({
      railName: '',
      // cdsn: '',
      // checkinDateTime: '',
      // checkOutDateTime: '',
      // welcomeMessage: ''
    });
  }

  const popupCloseHandler = () => {
    setDeletePublishUnPublishPopUp(false);
    // setPublishUnPublishPopUp(false);
  };

  // const publishUnPublishHandler = () => {
  //   const apiPath = `/rails/${isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.row?.sid}/${isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.row?.published ? "unpublish" : "publish"}`;
  //   callAPI(apiPath, "GET", {}, { chainId: getChainIdLS() })
  //     .then((res) => {
  //       setFlag(!flag)
  //       let successMessage = res.message
  //       const newModalRefData = {
  //         isPublishUnPublishModalData: {
  //           message: successMessage
  //         }
  //       };
  //       isPublishedUnPublishedRef.current = newModalRefData;
  //       railConfigurationListApi();
  //     })
  //     .catch((err) => {
  //       console.warn(err.message);
  //       setPublishUnPublishPopUp(false);
  //     });
  // }

  const deletePublishUnPublishPopUpHandler = (row) => {
    setDeletePublishUnPublishPopUp(true);
    const newModalRefData = {
      isPublishUnPublishDeletedModalData: {
        row
      },
      userConformationModalData: null,
    };
    isPublishUnPublishDeletedRef.current = newModalRefData;
  }

  const isPublishUnPublishDeletedRef = useRef({
    isPublishUnPublishDeletedModalData: null,
    userConformationModalData: null,
  });

  const isPublishedUnPublishedRef = useRef({
    isPublishUnPublishModalData: null,
  });

  const railListPreviewHandler = (row)=>{
    setRreviewListRowData(row);
    setPreview(true);
  }

  const columns = [
    { field: "createdOn", headerName: "Created On", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}</p> },
    { field: "railName", headerName: "Rail Name", flex: 1 },
    // { field: "roomTypes", headerName: "Room Types", flex: 1, row: true, renderCell: (row) => <p>{row?.roomTypes.map((room, index)=><span>{index?', ':''}<span></span>{room}</span>)}</p>},
    { field: "Preview", headerName: "Rail Preview", flex: 1, disableSortIcon: true, row: true, renderCell: (row) =>  <div className="rail-list-preview-eye" onClick={()=>railListPreviewHandler(row)}>Preview <BsEye /></div>},
    // { field: "checkoutDateTime", headerName: "Check-out date", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.checkoutDateTime).format("DD-MM-YYYY")}</p> },
    // { field: "welcomeMessage", headerName: "Welcome Message", flex: 1, row: true, renderCell: (row) => <Tooltip title={row?.welcomeMessage}><p className={`mb-0 ${row?.welcomeMessage.length > 10 ? 'overflow-ellipsis' : ''}`}>{row?.welcomeMessage}</p></Tooltip> },
    {
      field: "actionCell",
      row: true,
      headerName: "Actions",
      flex: 0.5,
      renderCell: renderActionIcon,
      sortDirection: false,
      disableSortIcon: true,
    },
  ];

  const railConfigurationListApi = () => {
    setLoader(true)
    const apiPath = `/rails-default`;
    callAPI(apiPath, "GET")
      .then((response) => {
        const sortedResponse = response?.sort((a, b) => b.createdOn- a.createdOn)
        setRailsConfigurationList(sortedResponse)
        setPartnerRailData([{partnerId: 4, sequenceNo: 0}])
        setChannelForYouData([])
        setHotelServiceData([])
        setHotelChannelData([])
        reset({ railName: ""});
        setValue(0)
        setEditPublishUnPublish(false);
        setPublishUnPublishSid({});
        setLoader(false)
      })
      .catch((err) => {
        console.warn(err.message)
        setLoader(false)
      });
      setIsEdit(false);
  };

  useEffect(() => {
    railConfigurationListApi()
    resetChainIdHandler()
  }, [chainId])

  const resetChainIdHandler = () =>{
    setPartnerRailData([])
    setChannelForYouData([])
    setHotelServiceData([])
    setHotelChannelData([])
    reset({ railName: "", roomTypes: "" });
    setValue(0)
    setEditPublishUnPublish(false);
    setPublishUnPublishSid({});
  }

  const tabChangeHandler = (tab) =>{
    setValue(tab)
  }

  const onSubmitHandler = () => {
    if(errors?.railName?.message){
      return;
    }
    const tabSequence = tabs?.map((tabData)=>({railName: tabData?.railName, sequenceNo:tabData?.sequenceNo}))
    const finalPayload = { ...payloadPartner, ...payloadChannelsForYou,...payloadHotelService, ...payloadHotelChannel, utility: [], showUtilities:showUtility , railOrder: tabSequence, railName: watch("railName")}
    const apiPath = `/rails-default`;
    let method = "POST"

    if (editPublishUnPublishUpdate) {
      method = "PUT"
      finalPayload.sid = publishUnPublishSid?.sid
    }
    setLoader(true);
    callAPI(apiPath, method, finalPayload, { chainId: getChainIdLS() })
      .then((response) => {
        setCreateRailSuccessMsg(response?.message)
        railConfigurationListApi()
        setPayloadPartner({})
        setPayloadChannelsForYou({})
        setPayloadHotelService({})
        setPayloadHotelChannel({})
        setPayloadUtility({})
        setLoader(false);
        setShowUtility(true)
      })
      .catch((err) => {
        console.warn(err.message);
        setLoader(false);
      });
  }

  return (
    <div className="config-hotel">
      {loader && <div className="circular-progress"><CircularProgress /></div>}
      <div className="left-column">
         <form className={`hotel-list-form ${isEdit ?"":railsConfigurationList?.length ?"page-mask":""} `}>
          {railsConfigurationList?.length>0 && !isEdit && <div className='mask-content default-config'>Only one default configuration can be created at a time. <br/> Please update existing one if required.</div> }
          <div className="row">
            <div className="left-column-header">
              <p>{editPublishUnPublish?"Edit Rail Configuration":"Rail Configuration"}</p>
            </div>
            <div className="form-group-hotel col-4">
              <div className={`floating-label ${validPermissionClassName}`}>
                {/* <FaHotel className="new-hotel-icons" /> */}
                <input
                  id="railName"
                  disabled={!isValidRole("RAIL_CONFIGURATION_MODIFY")}
                  placeholder=""
                  {...register("railName", {
                    required: "Enter Rail Name",
                    minLength: {
                      value: 3,
                      message: "Minimum of 3 characters"
                    },
                    maxLength: {
                      value: 25,
                      message: "Maximum of 25 characters"
                    }
                  })}
                />
                <label htmlFor="railName">Enter Rail Name</label>
              </div>
              {errors.railName && (
                <small className="required">{errors.railName.message}</small>
              )}
            </div>

            {/* <div className="col-4 form-group-hotel">
              <div className="floating-select-label">
                <Controller
                  name="roomTypes"
                  control={control}
                  rules={{
                    validate: value =>
                      Array.isArray(value) && value?.length > 0 || 'Please Select Room Type'
                  }}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      className={`multiselectlist ${field?.value && field?.value?.length > 0 ? 'Mui-focused' : ''}`}
                      limitTags={2}
                      disablePortal
                      multiple
                      options={roomTypesMaster}
                      getOptionLabel={(option) => option.toString()}
                      onChange={(_, newValue) => {
                        field.onChange(newValue);
                      }}
                      value={field.value || []}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder=""
                          variant="outlined"
                          label="Select Room Type"
                          InputLabelProps={{
                            shrink: false,
                          }}
                        />
                      )}
                    />
                  )}
                />
              </div>
              {errors.roomTypes && (
                <small className="required">{errors.roomTypes?.message}</small>
              )}
            </div> */}
          </div>
          {watch("railName") !== "" &&
            <DragDropContext onDragEnd={onDragEnd} onDragStart={()=>setIsDragging(true)}>
              <Droppable droppableId="tabs" direction="horizontal">
                {(provided) => (
                  <Box
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className={`boxroot ${isDragging ? 'dragging' : ''}`}
                  >
                    <Tabs
                      value={value}
                      onChange={handleChange}
                      variant="scrollable"
                      scrollButtons="auto"
                      TabIndicatorProps={{
                        hidden: true,
                        style: { transition: "none" },
                      }}
                    >
                      {tabs.map((tabData, index) => (
                        <Draggable
                          key={tabData?.id}
                          draggableId={`id-${tabData?.id}`}
                          index={tabData?.sequenceNo-1}
                          disableInteractiveElementBlocking={true}
                        >
                          {(provided) => (
                            <Tab
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              label={tabData?.label}
                              icon = {tabData?.icon}
                              iconPosition="start"
                              onClick={() => setValue(tabData?.sequenceNo-1)} // Set active tab
                              {...a11yProps(tabData?.sequenceNo-1)}
                            />
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </Tabs>
                    <TabPanel>
                      {renderTabContent()}
                    </TabPanel>
                  </Box>
                )}
              </Droppable>
            </DragDropContext>
          }
        </form>
        <div className="hotel-list">
          <p><b>Rail Configuration List</b></p>
          <TableWrapper
            data={railsConfigurationList?.length ? railsConfigurationList : []}
            columns={columns}
            module="publish-unpublish"
            noPagination={true}
          />
          {/* <Custom_Paingation
            selectedPage={selectedPage}
            totalPageCount={totalPageCount}
            paginationError={paginationError}
            inputPageValue={inputPageValue}
            setSelectedPage={setSelectedPage}
            setPaginationError={setPaginationError}
            setInputPageValue={setInputPageValue}
            onPageChange={onPageChange}
          /> */}
        </div>
      </div>

      <BasicModal
        popupOpen={deletePublishUnPublishPopUp}
        bodyMessage={<>
          <img src={deleteImg} alt="approve" className="w-40px" />
          <div className="delete-hotel mb-3">{isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData ?
            <div className="confirm-delete-hotel">
              <p>Do you really want to Delete Rail Configuration for "<b>{isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData.row.railName}</b>" ?</p>
              <p className="warning"><IoMdWarning /> Warning</p>
              <p>Rail Configuration "{isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData.row.railName}" will be permanently deleted <br />
                Deleting the specified Rail Configuration can't be undone.
              </p>
              <p className="mt-3">To confirm deletion, type "Delete Rail Configuration {isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData.row.railName}"</p>
              <div className="form-group-hotel mt-3">
                <div className="floating-label">
                  <input
                    id="deleteHotel"
                    // maxLength={40}
                    placeholder=''
                    onChange={(e) => setConfirmDeletePublishUnPublish(e.target.value)}
                  />
                  <label htmlFor="address">Delete Rail Configuration</label>
                </div>
                {(confirmDeletePublishUnPublish === "" && confirmValidate) ? (
                  <p className="text-start"><small className="required">Please Enter Delete Rail Configuration {isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData.row.railName}</small></p>
                ) : (confirmDeletePublishUnPublish !== `Delete Rail Configuration ${isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData.row.roomNo}` && confirmValidate) ? (
                  <p className="text-start"><small className="required">Please Enter Delete Rail Configuration {isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData.row.railName}</small></p>
                ) : ""
                }
              </div>
            </div> :
            isPublishUnPublishDeletedRef.current?.userConformationModalData?.successMessage}</div>
        </>
        }
        footer={
          isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData ?
            {
              primaryButton: {
                buttonName: "Cancel",
                action: popupCloseHandler
              }
              ,
              secondaryButton: {
                buttonName: "Delete",
                action: deletePublishUnPublishHandler
              }
            } : {
              secondaryButton: {
                buttonName: "OK",
                action: popupCloseHandler
              }
            }
        }
      />
      <BasicModal
        popupOpen={createRailSuccessMsg !== ""}
        logo={"/Images/approve-qc.png"}
        bodyMessage={<p className="mt-2">{createRailSuccessMsg}</p>}
        // customcss={true}
        footer={
          {
            secondaryButton: {
              buttonName: "OK",
              action: () => { setCreateRailSuccessMsg(''); setEditPublishUnPublishUpdate(false); },
              buttonPrimaryCustomCss: 'cancel-btn_new'
            }
          }
        }
      />

      <BasicModal
        popupOpen={preview}
        bodyMessage={<RailConfigPreview listPreview = {true} setPreview ={setPreview} previewListRowData= {previewListRowData} />}
        popupSize={'col-11 rails-preview'}
      />
    </div>
  )
}

export default RailConfig;